import { styled, Box, css } from '@mui/material';

export const SectionWrapper = styled(Box)(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1;
    padding: ${theme.spacing(1.5)} ${theme.spacing(3)};
    width: 100%;
  `,
);
